import { axios } from '@Root/API'

export const getStatic = () => {
	return Promise.all([axios.get('data-post-grad-status'), axios.get('data-post-grad-tcb-response'), axios.get('data-post-grad-uob-response')])
}
